<template>
  <div>
    <div class="text-center" v-if="!dataLoaded">
      <v-progress-circular class="mt-6" :size="50" color="primary" indeterminate />
    </div>

    <div class="mt-4" v-show="dataLoaded">

      <v-row class="my-0">
        <v-col cols="12" class="pt-0">

          <PageTable
            :table-loading="tableLoading"
            :table-headers="tableHeaders"
            :table-items="notifications.list"
            filter
            table-height="370"
          >
            <template v-slot:button>
              <v-badge
                overlap
                dot
                :value="!!checkProperty"
              >
                <v-btn
                  small
                  outlined
                  rounded
                  color="primary"
                  class="white--text ml-4 filter-btn"
                  @click="showFilter = !showFilter"
                >
                  <v-icon left small>mdi-filter-outline</v-icon>
                  <span class="">{{ showFilter ? 'Закрыть' : 'Фильтр' }}</span>
                </v-btn>
              </v-badge>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon color="lightGrey" class="mr-2 eye-btn" size="22" title="Просмотр" @click="show(item)">
                mdi-eye-outline
              </v-icon>
            </template>
          </PageTable>
        </v-col>
      </v-row>
    </div>

    <transition name="fade">
      <NotificationsFilters
        v-show="showFilter"
        @applyFilter="applyFilter"
        @closeFilter="showFilter = false"
        :notification-for-filter="notificationForFilter"
        width-filter="300"
        top="291"
        right="29"
      />
    </transition>

    <UniversalConfirmDialog
      :type="typeDialog"
      :selectedItem="selectedItem"
      @closeDialog="closeDialog"
    />
  </div>
</template>

<script>
import { notificationApi } from '@/api'
import { Notifications, NotificationForFilter } from '@/models'
import PageTable from '@/components/ui/Table'
import NotificationsFilters from '@/components/zvp/notificationManagement/NotificationsFilters'
import UniversalConfirmDialog from '@/components/dialogs/UniversalDialog'

export default {
  name: 'ReportSummary',

  components: {
    PageTable,
    NotificationsFilters,
    UniversalConfirmDialog
  },

  async created() {
    await this.$store.dispatch('user/getCurrent')
    await this.getGroups()
    this.dataLoaded = true
  },

  data: () => ({
    tableHeaders: [
      { text: 'Номер', value: 'id', sortable: false, align: 'start' },
      { text: 'Тема', value: 'name', sortable: false, align: 'start' },
      { text: 'Курс', value: 'courseNumber.name', sortable: false, align: 'start' },
      { text: 'Специальность', value: 'speciality.name', sortable: false, align: 'start' },
      { text: 'ФИО', value: 'addresseeName', sortable: false, align: 'start' },
      { text: 'E-mail', value: 'addressee.0.email', sortable: false, align: 'start' },
      { text: 'Формат', value: 'notificationFormat.name', sortable: false, align: 'start' },
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '40px' }
    ],

    notifications: new Notifications(),
    notificationForFilter: new NotificationForFilter(),
    tableLoading: false,
    filter: '',
    selectedItem: null,
    dataLoaded: false,
    typeDialog: null,
    showFilter: false,
    pageNumber: 0,
    lastPage: false,
  }),

  computed: {
    checkProperty() {
      return this.notificationForFilter.courseNumber || this.notificationForFilter.speciality
    },
  },

  methods: {
    async applyFilter(item) {
      this.notificationForFilter = item ? item : new NotificationForFilter()
      this.notifications.list = []
      this.pageNumber = 0
      this.lastPage = false
      await this.getGroups()
    },

    async getGroups() {
      this.notificationForFilter.notificationStatusId = 1 //значение для фильтра всех отправленных уведомлений
      try {
        if (!this.lastPage) {
          this.tableLoading = true
          const { content, last } = await notificationApi.filterNotifications(this.pageNumber, this.notificationForFilter.getForAPI())
          this.lastPage = last
          this.pageNumber++

          content?.length && content.forEach(obj => this.notifications.addNotification(obj))
          !this.notifications.list.length && this.$toastr('warning', '', `Поиск не дал результатов`)
        }
      } catch (e) {
        this.$toastr('error', `<b>Код ошибки: ${e.status}</b>`, 'Возникла ошибка')
      } finally {
        this.tableLoading = false
      }
    },

    show(item) {
      this.selectedItem = item
      this.typeDialog = 'checkMsg'
    },

    closeDialog() {
      this.typeDialog = null
      this.selectedItem = null
    },
  },
}
</script>

<style scoped>

.fade-enter-active {
  transition: opacity .2s;
}

.fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.filter-btn {
  width: 150px;
}

.filter-btn span {
  width: 70px;
}
</style>
